module.exports = __webpack_public_path__ + "img/14.553cdc1d.jpg";